import React from "react";
import "./TermsConditions.css";

const Deliverypolicy = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1 className="terms-title">
          Cancellation, Delivery & Return Policy
        </h1>

        <div className="terms-section">
          <h2>Failure to Collect Vehicle</h2>
          <p>
            If the Customer fails to collect the vehicle at the scheduled pickup
            time, or cancels the reservation more than three (3) hours after
            the confirmed booking time, MAS Mobility Service reserves the right
            to charge the full rental value of the first rental day.
          </p>
        </div>

        <div className="terms-section">
          <h2>Missing Required Documents</h2>
          <p>
            The Customer must provide all required official documents,
            including a valid National ID, Iqama, Passport (where applicable),
            and a valid Driving License.
          </p>

          <p>
            If the required documents are not provided, MAS Mobility Service
            reserves the right to refuse vehicle delivery and charge the rental
            value of the first rental day.
          </p>
        </div>

        <div className="terms-section">
          <h2>Authorization Issues</h2>
          <p>
            If the Customer is unable to complete authorization due to legal
            or regulatory reasons, including but not limited to:
          </p>

          <ul>
            <li>Expired driving license</li>
            <li>Suspension of government services</li>
            <li>Failure to update information on government platforms</li>
            <li>Visa-related restrictions</li>
            <li>Other legal limitations preventing rental</li>
          </ul>

          <p>
            MAS Mobility Service reserves the right to deduct 25% of the rental
            value of one (1) rental day.
          </p>
        </div>

        <div className="terms-section">
          <h2>Refund Processing Timeline</h2>
          <p>
            Any approved refund shall be processed within seven (7) to
            twenty-one (21) business days, subject to banking procedures and
            company financial policies.
          </p>
        </div>

        <div className="terms-section">
          <h2>Security Deposit Terms</h2>
          <p>
            Security deposits may apply to certain customer categories,
            including GCC nationals and visit visa holders.
          </p>

          <p>
            The deposit will be refunded within twenty-one (21) business days
            after vehicle return, provided there are no traffic violations,
            vehicle damages, or outstanding charges.
          </p>
        </div>

        <div className="terms-section">
          <h2>Free Cancellation Policy</h2>
          <p>
            Customers may cancel their reservation free of charge if the
            cancellation request is submitted through approved communication
            channels at least twenty-four (24) hours before the scheduled
            pickup time.
          </p>
        </div>

        <div className="terms-section">
          <h2>Late Cancellation Fee</h2>
          <p>
            If a reservation is cancelled less than twenty-four (24) hours
            before pickup, or if the Customer does not appear, MAS Mobility
            Service reserves the right to charge a minimum of one (1) rental
            day.
          </p>

          <p>
            Charges may be deducted from advance payments, security deposits,
            or prepaid rental amounts and are generally non-refundable unless
            otherwise approved in writing.
          </p>
        </div>

        <div className="terms-section">
          <h2>Vehicle Return Grace Period</h2>
          <p>
            Customers are granted a one (1) hour complimentary grace period
            after the scheduled return time.
          </p>

          <h3>Delays Up to Three Hours</h3>
          <p>
            If the vehicle is returned after the grace period but within three
            (3) additional hours, late charges will apply on an hourly basis.
          </p>

          <h3>Delays Exceeding Four Hours</h3>
          <p>
            If the delay exceeds four (4) hours from the scheduled return time,
            an additional full rental day charge may apply.
          </p>
        </div>

        <div className="terms-section">
          <h2>Vehicle Delivery</h2>
          <p>
            Vehicle delivery services may be available within designated
            service areas. Delivery timing depends on vehicle availability,
            traffic conditions, and operational requirements.
          </p>

          <p>
            Customers must be present at the agreed location with valid
            identification and required documentation.
          </p>
        </div>

        <div className="terms-section">
          <h2>Contact Information</h2>
          <p>
            MAS Mobility Service <br />
            Jeddah, Kingdom of Saudi Arabia
          </p>

          <p>
            For questions regarding cancellations, refunds, vehicle delivery,
            or return policies, please contact our customer support team.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Deliverypolicy;